/**
 * The resident's Telegram profile photo for the profile card (backlog «фото жителя в профиле»). Telegram puts
 * `photo_url` into the signed initData `user` field when the user's privacy settings allow it; like `start_param`
 * it is read from initData, never from initDataUnsafe. Display only — it plays no part in sign-in.
 */
const TELEGRAM_HOSTS = /(^|\.)(t\.me|telegram\.org|telesco\.pe)$/i;

export function telegramPhotoUrl(initData: string): string | null {
  const raw = new URLSearchParams(initData).get('user');
  if (!raw) return null;
  let value: unknown;
  try {
    value = (JSON.parse(raw) as { photo_url?: unknown }).photo_url;
  } catch {
    return null;
  }
  if (typeof value !== 'string') return null;
  try {
    const url = new URL(value);
    // Only an https picture from Telegram: the value ends up in <img src>.
    return url.protocol === 'https:' && TELEGRAM_HOSTS.test(url.hostname) ? url.href : null;
  } catch {
    return null;
  }
}
